import { render } from "./ProposalLogbookModal.vue?vue&type=template&id=f5730520"
import script from "./ProposalLogbookModal.vue?vue&type=script&lang=js"
export * from "./ProposalLogbookModal.vue?vue&type=script&lang=js"

import "./ProposalLogbookModal.vue?vue&type=style&index=0&id=f5730520&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__